/**
 * <free-shipping-message>: keeps the free shipping message (amount left + progress bar) current.
 * Markup: snippets/component-free-shipping.liquid
 *
 * section-main-cart.js patches line items in place on quantity changes and doesn't re-render the
 * message, so after its `cart:updated` event this fetches the cart section and copies in the
 * fresh server-rendered message (Shopify does the money formatting and threshold math).
 */
if (!customElements.get('free-shipping-message')) {
  let pendingFetch = null;

  // One request per burst of cart updates, shared by every message on the page.
  const fetchFreshMessage = () => {
    pendingFetch ??= fetch(`${window.Shopify?.routes?.root || '/'}cart?section_id=main-cart`)
      .then((response) => (response.ok ? response.text() : Promise.reject(new Error(response.status))))
      .then((html) => new DOMParser().parseFromString(html, 'text/html').querySelector('free-shipping-message'))
      .finally(() => {
        setTimeout(() => {
          pendingFetch = null;
        });
      });
    return pendingFetch;
  };

  class FreeShippingMessage extends HTMLElement {
    connectedCallback() {
      this.onCartUpdated = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.refresh(), 150);
      };
      document.addEventListener('cart:updated', this.onCartUpdated);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdated);
      clearTimeout(this.timer);
    }

    async refresh() {
      try {
        const fresh = await fetchFreshMessage();
        if (!fresh || !this.isConnected) return;
        this.innerHTML = fresh.innerHTML;
        // The theme hides icons until they're marked loaded (as section-main-cart.js does).
        this.querySelectorAll('.icon').forEach((icon) => icon.classList.add('loaded'));
      } catch (error) {
        // Keep the current message if the refresh fails.
      }
    }
  }

  customElements.define('free-shipping-message', FreeShippingMessage);
}
